import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useLanguage } from "../../context/LanguageContext";

export const Footer = () => {
  const { content } = useLanguage();
  const ui = content.ui;
  const [email, setEmail] = useState("");

  const explore = [
    { to: "/matieres-premieres", label: ui.nav.commodities },
    { to: "/a-propos", label: ui.nav.about },
    { to: "/expertise", label: ui.nav.expertise },
    { to: "/pourquoi-nous", label: ui.nav.why },
    { to: "/exportation", label: ui.nav.export },
    { to: "/contact", label: ui.nav.contact },
  ];

  const onSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("Merci ! Vous êtes bien inscrit.");
    setEmail("");
  };

  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden bg-brand-green text-white"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12 md:py-28">
        <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="font-serif text-4xl tracking-tight">
              Lauréate <span className="text-brand-gold">Commodity</span>
            </Link>
            <p className="mt-6 max-w-sm text-base leading-relaxed text-white/70">
              {ui.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] text-brand-gold">
              {ui.footer.explore}
            </p>
            <ul className="mt-6 space-y-3">
              {explore.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.slice(1)}`}
                    className="text-white/70 transition-colors hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-brand-gold">
              {ui.footer.newsletter}
            </p>
            <form onSubmit={onSubscribe} className="mt-6 flex items-center border-b border-white/25">
              <input
                data-testid="footer-newsletter-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={ui.footer.emailPlaceholder}
                className="w-full bg-transparent py-3 text-white placeholder:text-white/40 focus:outline-none"
              />
              <button
                data-testid="footer-newsletter-submit"
                type="submit"
                className="ml-3 text-xs uppercase tracking-[0.15em] text-brand-gold transition-opacity hover:opacity-70"
              >
                {ui.footer.subscribe}
              </button>
            </form>
            <div className="mt-8 space-y-1 text-sm text-white/60">
              <p>{content.contact?.email}</p>
              <p>{content.contact?.address}</p>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/50 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Lauréate Commodity. {ui.footer.rights}</p>
          <div className="flex gap-6">
            <Link to="/politique-confidentialite" data-testid="footer-privacy" className="transition-colors hover:text-white">
              {ui.footer.privacy}
            </Link>
            <Link to="/mentions-legales" data-testid="footer-mentions" className="transition-colors hover:text-white">
              {ui.footer.mentions}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
